<template>
	<div 
		:id="`FrameContainer-${item.frameId}`"
		class="row no-gutters position-relative" 
	>
		<div class="col-12 title-frame" v-if="item.frameType === 'script'">
			<template v-if="!isRunCode">
				<textarea
					placeholder="Insira seu código de script aqui"
					v-model="item.frameContent"
					rows="5"
					class="form-control px-0"
					
				></textarea>
			</template>
			<div class="col-12" v-html="item.frameContent" v-else></div>
		</div>

		<div
			class="col-12 title-frame mb-3"
			v-else-if="item.frameType === 'title'"
		>
			<TitleBlock
				:title="item.frameContent"
				:extra="item.extra"
				:defaultColors="getDefaultStyles('title')"
				:hasImageBackground="hasImageBackground"
				:showSettings="showSettingsChilds"
				@changeTitle="item.frameContent = $event"
				@deleteFrameChild="() => $emit('deleteFrameChild')"
				@openSettingsFrameChild="() => $emit('openSettingsFrameChild')"
			/>
		</div>

		<div
			v-else-if="item.frameType === 'text'"
			:style="getExtraStyle(item)"
			class="col-12 editor-mobile text-frame mt-3 position-relative"
		>
			<base-image
				v-if="item.extra != null && item.extra.background_image != null"
				:source="item.extra.background_image.uri"
				custom-class="position-absolute ps-0 w-100 h-100 img-fluid"
				:style="
					{
						'z-index': '0',
						'object-position': validadeFocalPoint(item.extra != null && item.extra.background_image_focal_point != null ? item.extra.background_image_focal_point : null),
						'opacity': `${item.extra != null && item.extra.background_image_opacity ? item.extra.background_image_opacity : 80}%`,
						'object-fit': 'cover'
					}
				"
			/>

			<TinyEditor
				:frameType="'text'"
				:textContent="item.frameContent"
				@contentText="checkToConvert($event, item)"
				:extra="item.extra"
				:defaultColors="getDefaultStyles('text')"
				:hasImageBackground="hasImageBackground"
				v-if="item.component != 'address-data'"
				:showSettings="showSettingsChilds"
				@deleteFrameChild="() => $emit('deleteFrameChild')"
				@openSettingsFrameChild="() => $emit('openSettingsFrameChild')"
			></TinyEditor>

			<p v-else>Informações das redes sociais</p>
		</div>

		<div v-else-if="item.frameType === 'image'" class="imgClass col-12 d-flex justify-content-center py-2">
			<ImageBlock
				:imagePath="item.frameContent"
				:imageWidth="item.width"
				:imageHeight="item.height"
				:isFullWidth="item.grid == 99"
				:extra="item.extra"
				:showSettings="showSettingsChilds"
				:isChild="isFrameContainer"
				@deleteFrameChild="() => $emit('deleteFrameChild')"
				@openSettingsFrameChild="() => $emit('openSettingsFrameChild')"
			/>
		</div>

		<div v-else-if="item.frameType === 'gallery'" class="imgClass col-12">
			<GalleryPictures
				:siteId="siteId"
				:galleryData="item.frameContent"
				:postType="postType"
				:cols="item.grid"
				:itemsPerLine="item.extra != null && item.extra.maincontent_gallery_items != null ? item.extra.maincontent_gallery_items : '3'"
				@updateContent="item.frameContent = $event"
				@openMediaManager="openMediaManager(item.frameContent)"
			/>
		</div>

		<div v-else-if="item.frameType === 'page'" class="imgClass col-12">
			<span>{{ item.frameType }}</span>
		</div>

		<div v-else-if="item.frameType === 'slider'" class="imgClass col-12">
			<GalleryPictures
				:siteId="siteId"
				:galleryData="item.frameContent"
				:isFrameContainer="isFrameContainer"
				:cols="item.grid"
				@updateContent="item.frameContent = $event"
				@openMediaManager="openMediaManager(item.frameContent)"
			/>
		</div>

		<div v-else-if="item.frameType === 'form'" class="col-12 p-0">
			<FormComponent :formContent="item" />
		</div>

		<div v-else-if="item.frameType === 'card_list'" class="col-12 p-0">
			<CardListComponent :cardListContent="item" />
		</div>

		<div v-else-if="item.frameType === 'location'" class="col-12">
			<LocationComponent :siteId="siteId" />
		</div>

		<div v-else-if="item.frameType === 'button'" class="col-12 mt-4">
			<ButtonBlock
				:frameContent="item.frameContent"
				:showSettings="showSettingsChilds"
				:extra="item.extra"
				:defaultColors="getDefaultStyles('button')"
				@deleteFrameChild="() => $emit('deleteFrameChild')"
				@openSettingsFrameChild="() => $emit('openSettingsFrameChild')"
			/>
		</div>

		<div v-else-if="item.frameType === 'beforeAfterImage'" class="col-12">
			<div>
				<BeforeAfterImageComponent
					:grid="item.grid"
					:content="item.frameContent"
				/>
			</div>
		</div>

		<div 
			v-else-if="item.frameType === 'container'"
			class="col-12"
		>
			<div class="row">
				<div
					v-for="(subItem, subItemIndex) in item.frameContent"
					:key="subItem.index"
					:class="`col-${subItem.grid}`"
				>
					<FrameContainer
						:item="subItem"
						:key="subItemIndex"
						:index="subItemIndex"
						:isFrameContainer="true"
						:sectionIndex="sectionIndex"
						:showSettingsChilds="showSettingsChilds"
						:hasImageBackground="item.extra && item.extra.background_image && item.extra.background_image.uri != null"
						@deleteFrameChild="() => $emit('deleteFrameChild', subItemIndex)"
						@openSettingsFrameChild="() => $emit('openSettingsFrameChild', subItemIndex)"
						@changeImageFromGallery="changeImageFromGallery"
					/>
				</div>
			</div>
		</div>

		<div v-else-if="item.frameType === 'video'" class="col-12">
			<div class="embed-responsive embed-responsive-16by9">
				<iframe
					class="embed-responsive-item"
					frameborder="0"
					:src="
						typeof item.frameContent === 'string'
							? item.frameContent
							: item.frameContent.embed
					"
					allowfullscreen
				></iframe>
			</div>
		</div>

		<div v-else-if="item.frameType === 'music'" class="col-12">
			<span v-if="item.frameContent !== null && item.frameContent.embed">
				<div class="embed-responsive embed-responsive-16by9">
					<iframe
						class="embed-responsive-item"
						frameborder="0"
						v-if="
							item.frameContent.embed.match(/soundcloud/g) ===
							null
						"
						:src="
							typeof item.frameContent === 'string'
								? item.frameContent
								: item.frameContent.embed
						"
						allowfullscreen
						allow="encrypted-media"
						allowtransparency="true"
					></iframe>
					<div v-else v-html="item.frameContent.embed"></div>
				</div>
			</span>
		</div>

		<div v-else-if="item.frameType === 'comments'" class="col-12">
			<CommentsComponent
				:editable="true"
				@updateOrderComments="updateOrder($event)"
				:comments="item.frameContent"
				:frameId="item.frameId"
			/>
		</div>

		<div v-else-if="item.frameType === 'faq'" class="col-12">
			<FaqComponent
				:formContent="item"
			/>
		</div>

		<div v-else class="col-12">
			<h5>Erro ao recuperar conteúdo.</h5>
			{{ item }}
		</div>
	</div>
</template>
<script>
	import TinyEditor from "@/components/organisms/TinyEditor.vue"
	import BeforeAfterImageComponent from "@/components/organisms/BeforeAfterImageComponent.vue";
	import CommentsComponent from "@/components/blocks/CommentsComponent.vue";
	import CardListComponent from '@/components/organisms/CardListComponent';
	import FormComponent from "@/components/blocks/FormComponent.vue";
	import TitleBlock from "@/components/blocks/TitleBlock.vue";
	import GalleryPictures from "@/components/molecules/GalleryPictures.vue";
	import Group from "@/components/blocks/Group";
	import GroupHome from "@/components/blocks/GroupHome";
	import ImageBlock from "@/components/blocks/ImageBlock";
	import LocationComponent from "@/components/blocks/LocationComponent.vue";
	import PostButtonComponent from "@/components/organisms/PostButtonComponent.vue";
	import SliderComponent from "@/components/blocks/SliderComponent.vue";
	import FaqComponent from "@/components/blocks/FaqComponent.vue";
	import apiMixins from "@/mixins/apiMixins";

	import { Carousel3d, Slide } from "vue-carousel-3d";
	import ButtonBlock from "./ButtonBlock.vue";
	import BaseImage from '../atoms/BaseImage.vue';
	import { mapGetters } from 'vuex';

	export default {
		name: "FrameContainer",
		data() {
    		return {
				layoutStyles: [],
			}
		},
		components: {
			BeforeAfterImageComponent,
			Carousel3d,
			CommentsComponent,
			FormComponent,
			GalleryPictures,
			Group,
			GroupHome,
			ImageBlock,
			LocationComponent,
			PostButtonComponent,
			Slide,
			SliderComponent,
			TinyEditor,
			FaqComponent,
			CardListComponent,
			TitleBlock,
			ButtonBlock,
			BaseImage
		},
		mixins: [apiMixins],
		props: {
			defaultColorsActive: {
				type: Boolean,
				default: true,
			},
			item: {
				type: Object,
				required: true,
			},
			index: {
				type: Number,
				required: true,
			},
			postId: {
				type: Number,
				required: false,
			},
			siteId: {
				type: Number,
			},
			sketch: {
				type: Number,
			},
			postType: {
				type: String,
			},
			isFrameContainer: {
				type: Boolean,
				default: false,
			},
			showSettingsChilds: {
				type: Boolean,
				default: false,
			},
			sectionIndex: {
				type: Number,
				default: null,
			},
			hasImageBackground: {
				type: Boolean,
				default: false,
			},
		},
		async created() {
			this.layoutStyles = this.getLayoutStyles;

			// Caso o titulo sejá de Store e esteja vazio aplica o nome da Store
			if(this.item.frameType === 'title' && this.item.component === 'storelist' && !this.item.frameContent){
				const url = `/site/${this.$session.get("siteId")}/section/flat`
            	const { content } = await this.requestApiData(url, 'get')
				content.some((e) => { if(e.type === "store") this.item.frameContent = e.name })
			}
		},
		methods: {
			getDefaultStyles(type) {
				if (!this.defaultColorsActive) {
					return {};
				}

				const stylesMappings = {
					title: {
						colorDefault: this.sectionIndex % 2 == 0 ? this.layoutStyles.find(color => color.id === 'titleColor').value : this.layoutStyles.find(color => color.id === 'titleSecondaryColor').value,
						colorInverted: this.layoutStyles.find(color => color.id === 'invertedTitleColor').value,
					},
					text: {
						colorDefault: this.sectionIndex % 2 == 0 ? this.layoutStyles.find(color => color.id === 'textColor').value :  this.layoutStyles.find(color => color.id === 'textSecondaryColor').value,
						colorInverted: this.layoutStyles.find(color => color.id === 'invertedTextColor').value,
					},
					button: {
						backgroundDefault: this.layoutStyles.find(color => color.id === 'backgroundColorButton').value,
						colorDefault: this.layoutStyles.find(color => color.id === 'colorTextButton').value,
						fontWeight: this.layoutStyles.find(color => color.id === 'fontWeightButton').value,
					},
					// Adicione mais tipos de estilos e mapeamentos aqui, se necessário.
				};

				if (type) {
					return stylesMappings[type];
				}

				return stylesMappings;
			},
			validadeFocalPoint(focalPoint) {
				if (focalPoint == null) {
					return 'center center';
				}
				return `${focalPoint.x}% ${focalPoint.y}%`;
			},
			updateOrder,
			updateImage,
			removePhotoList,
			addImageList,
			checkToConvert(text, item) {
				//remove tags html
				var check = text.replace(/<\/?[^>]+>/ig, "")
				// remove espacamentos no comeco e no fim da div
				check = check.trim()
				item.frameContent = text;

				if (check.split(" ").length === 1 || check.split(" ").length === 3) {
					text = check.replace(/\<a\>|\<\/a>|\<p\>|\<\/p\>|\<br\>/g, "");

					const matchesVideo = text.match(
						/^((https:|http:)\/\/){0,1}w{0,3}\.{0,1}(youtu|vimeo\.com\/\d+).+$/gm
					);
					const matchesMusic = text.match(
						/(https:\/\/){0,1}(open\.spotify\.com)\/(track|playlist|album|show|user|artist|episode)|soundcloud\.com\/.+/gm
					);

					if (matchesVideo !== null || matchesMusic !== null) {
						if (matchesVideo !== null) {
							this.$emit("changeTextToVideo", text);
							return true;
						} else if (matchesMusic !== null) {
							this.$emit("changeTextToMusic", text);
							return true;
						}
					}
					return false;
				}
			},
			openMediaManager() {
				this.$emit("openMediaManager");
			},
			changeImageFromGallery(image) {
				this.$emit("changeImageFromGallery", image);
			},
			getExtraStyle(frame) {
				let style = {};
				
				style['backgroundColor'] = frame.extra != null && frame.extra.background_color != null
					? frame.extra.background_color
					: 'transparent'
				
				return style;
			},
		},
		computed:{
			...mapGetters("dashboardModule", [
				"getLayoutStyles",
			]),
			isRunCode: function(){
				if(this.item.runCode != undefined){
					return this.item.runCode
				}
				return true
			},
		},
	};
	function updateImage(siteId, response) {
		// console.log(response);
	}
	function removePhotoList(event) {
		this.$emit("removePhotoList", event);
	}
	function addImageList(event) {
		this.$emit("addImageList", event);
	}
	function updateOrder(event) {
		this.item.frameContent = event;
	}
</script>

<style scoped>
	.titulo--post {
		background-color: transparent;
		font-size: 1.5rem;
		font-weight: 600;
		font-family: "Montserrat", sans-serif;
	}
	.div-map {
		height: 650px;
		background-image: url("../../assets/img/default-google-maps.jpg");
	}
	.container {
		position: relative;
		width: 100%;
		height: 0;
		padding-bottom: 56.25%;
		margin: 36px 0 36px 0;
	}
	.video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	@media (max-width: 576px){
		.editor-mobile {
			padding-right: 0px !important;
			padding-left: 0px !important;
	}}
	.tox-editor-header{
		visibility: hidden !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/blocks/FrameContainer.vue